import { useState, useEffect, useRef } from "react";

export default function TextInput(props) {
    //LOGIC
    const [value, setValue] = useState(props?.value ?? '');
    const [status, setStatus] = useState(false);
    const myRef = useRef(null)
 

    useEffect(()=>{
        if (props.sol == value){
            myRef.current.classList.add("bg-green-100")
            myRef.current.classList.remove("bg-red-100")
            myRef.current.classList.remove("bg-gray-50")
            setStatus(true)
            console.log(status)
        }
        else if(value == ""){
            myRef.current.classList.remove("bg-red-100")
            myRef.current.classList.remove("bg-green-50")
            myRef.current.classList.add("bg-gray-100")
            setStatus(false)
        }
        else{
            myRef.current.classList.remove("bg-green-100")
            myRef.current.classList.remove("bg-gray-50")
            myRef.current.classList.add("bg-red-100")
            setStatus(false)
        }

}, [value])

   

    //RENDER
    return (<>
        <input data-status={status}  ref={myRef}  className="input inline-block mx-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" type="text"    onChange={e => setValue(e.target.value)} size="3" />

    </>)
}